module.exports = __webpack_public_path__ + "4973c5a8f0ebfb5837e6e467ffa9676d.png";